import { render, staticRenderFns } from "./LexonTextAreaComponent.vue?vue&type=template&id=8d00491c&scoped=true&lang=pug"
import script from "./LexonTextAreaComponent.vue?vue&type=script&lang=ts"
export * from "./LexonTextAreaComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonTextAreaComponent.vue?vue&type=style&index=0&id=8d00491c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d00491c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d00491c')) {
      api.createRecord('8d00491c', component.options)
    } else {
      api.reload('8d00491c', component.options)
    }
    module.hot.accept("./LexonTextAreaComponent.vue?vue&type=template&id=8d00491c&scoped=true&lang=pug", function () {
      api.rerender('8d00491c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonTextArea/LexonTextAreaComponent.vue"
export default component.exports